import { cn as i } from "../../../lib/utils.es.js";
import { jsx as t } from "react/jsx-runtime";
var r = i("lib:flex lib:h-11 lib:w-full lib:min-w-0 lib:border-dark-60 lib:border-b lib:bg-transparent lib:px-0 lib:pt-2 lib:pb-1 lib:outline-none lib:transition-[color,box-shadow] lib:selection:bg-muted lib:selection:text-foreground lib:file:inline-flex lib:file:h-7 lib:file:rounded-2xl lib:file:border-0 lib:file:bg-primary lib:file:px-2 lib:file:font-normal lib:file:text-small-xl lib:file:text-white lib:placeholder:text-muted-foreground lib:disabled:pointer-events-none lib:disabled:cursor-not-allowed lib:disabled:opacity-50 lib:aria-invalid:border-destructive lib:aria-invalid:ring-destructive/20", "lib:text-medium-sm lib:md:text-medium-md");
function a({ className: l, type: e, ...b }) {
  return /* @__PURE__ */ t("input", {
    className: i(r, l),
    "data-slot": "input",
    type: e,
    ...b
  });
}
export {
  a as BaseInput,
  r as baseInputClassname
};
